import { Node, mergeAttributes } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";
import SignatureNodeView from "@/features/document-editor/ui/SignatureNodeView.vue";

export const SignatureNode = Node.create({
  name: "signature",
  group: "block",
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      participant_type_code: {
        default: null,
        parseHTML: (el) => el.getAttribute("data-participant-type-code"),
        renderHTML: (attrs) => ({
          "data-participant-type-code": attrs.participant_type_code,
        }),
      },
      participant_name: {
        default: "",
        parseHTML: (el) => el.getAttribute("data-participant-name"),
        renderHTML: (attrs) => ({
          "data-participant-name": attrs.participant_name,
        }),
      },
      participant_type: {
        default: "participant",
        parseHTML: (el) => el.getAttribute("data-participant-type"),
        renderHTML: (attrs) => ({
          "data-participant-type": attrs.participant_type,
        }),
      },
      signatureVersion: {
        default: 0,
        renderHTML: () => ({}),
      },
    };
  },

  addOptions() {
    return {
      mode: "edit",
      hidePending: false,
    };
  },

  addStorage() {
    return {
      signatures: [],
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-signature]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-signature": "",
      }),
    ];
  },

  addNodeView() {
    return VueNodeViewRenderer(SignatureNodeView);
  },

  addCommands() {
    return {
      insertSignature:
        (attrs) =>
        ({ chain }) => {
          return chain()
            .insertContent([
              {
                type: this.name,
                attrs: {
                  participant_type_code: attrs.participant_type_code,
                  participant_name: attrs.participant_name,
                  participant_type: attrs.participant_type || "participant",
                },
              },
              {
                type: "paragraph",
              },
            ])
            .focus()
            .run();
        },
    };
  },
});
